import { Box } from '@/components';
import {
  BORDER_STYLE_PRIMARY,
  BORDER_STYLE_SECONDARY,
} from '@/features/mold/components';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  widthStyle?: string | number;
};

export const ReportTd: FC<Props> = ({ children, widthStyle }) => {
  return (
    <td
      style={{
        width: widthStyle,
        padding: 0,
        border: BORDER_STYLE_SECONDARY,
        borderLeft: BORDER_STYLE_PRIMARY,
        borderRight: BORDER_STYLE_PRIMARY,
      }}
    >
      <Box display="grid" height="100%">
        {children}
      </Box>
    </td>
  );
};
